module.exports = __webpack_public_path__ + "images/emoji/joy.b2d25aab62cc1a6987d5.png";